import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Preloader() {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), 2700);
    return () => clearTimeout(t);
  }, []);
  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#050505]"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.85, ease: [0.16, 1, 0.3, 1] }}
          data-testid="preloader"
        >
          <motion.img
            src="/logo-full.png"
            alt="Catalyst Petrochem LLP"
            className="w-64 md:w-96"
            initial={{ opacity: 0, scale: 0.78, y: 24, filter: "blur(14px)" }}
            animate={{ opacity: 1, scale: 1, y: 0, filter: "blur(0px)" }}
            transition={{ duration: 1.15, ease: [0.16, 1, 0.3, 1] }}
          />
          <motion.div
            className="mt-10 h-px bg-brand"
            initial={{ width: 0 }}
            animate={{ width: 200 }}
            transition={{ duration: 1.2, delay: 0.6, ease: "easeInOut" }}
          />
          <motion.p
            className="mt-5 font-mono text-[10px] uppercase text-neutral-500"
            initial={{ opacity: 0, letterSpacing: "0.2em" }}
            animate={{ opacity: 1, letterSpacing: "0.5em" }}
            transition={{ duration: 1.4, delay: 0.7, ease: "easeOut" }}
          >
            Thriving the world
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
